require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-closed-in-observance-of-labor-day.json") })
        }
      }, "path---es-articles-closed-in-observance-of-labor-day");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-closed-in-observance-of-labor-day!./.cache/json/es-articles-closed-in-observance-of-labor-day.json
// module id = 2047
// module chunks = 231608221292675